export const VERSION = Object.freeze({
    CURRENT: '1.65.34'
});

export const APIURLS = Object.freeze({
   // Vodafone IDP CRM
   CUSTOMER_Search_Lookup: '/profile/lookup',
   CUSTOMER_Search_Lookup_Ro: '/webusers',
   CUSTOMER_Search_Lookup_Vo: '/vodacom/webusers',
   CUSTOMER_Search_Lookup_AL: '/al/webusers',
   CUSTOMER_Search_Details_AL:'/al/webusers/{sub}',
   CUSTOMER_Search_Lookup_CZ: '/cz/webusers',
   CUSTOMER_Search_Details_CZ:'/cz/webusers/{sub}',
   CUSTOMER_Search_Lookup_IT: '/it/webusers',
   CUSTOMER_Search_Details_IT:'/it/webusers/{sub}',
   CUSTOMER_Search_Details: '/profile/{sub}/full',
   CUSTOMER_Search_Details_Ro: '/webusers/{sub}',
   CUSTOMER_Search_Details_Vo: '/vodacom/webusers/{sub}',
   CUSTOMER_Details_Update: '/profile/{sub}',
   CUSTOMER_Details_Update_Ro: '/webusers/{sub}',
   CUSTOMER_Details_Update_Al: '/al/webusers/{sub}',
   CUSTOMER_Details_Update_Cz: '/cz/webusers/{sub}', 
   CUSTOMER_Details_Update_It: '/it/webusers/{sub}', 
   CUSTOMER_Details_Update_Vo: '/vodacom/webusers/{sub}',
   CUSTOMER_Search_Email_Verify: '/comm/email/verify-email/{sub}',
   CUSTOMER_Search_Operations_Password_Reset: '/comm/email/reset-password/{sub}',
   RO_CUSTOMER_Search_Operations_Password_Reset:'/resetpassword',
   AL_CUSTOMER_Search_Operations_Password_Reset:'/al/resetpassword',
   CZ_CUSTOMER_Search_Operations_Password_Reset:'/cz/resetpassword',
   IT_CUSTOMER_Search_Operations_Password_Reset:'/it/resetpassword',
   VO_CUSTOMER_Search_Operations_Password_Reset:'/resetpasswordVo',
   VO_CUSTOMER_Search_Operations_Pin_Reset:'/resetpinVo',
   RO_CUSTOMER_Search_Operations_Send_Activation_Email:'/webusers/{sub}/send-activation-email',
   CUSTOMER_Search_Operations_Logout: '/customer/logout',
   CUSTOMER_KYC: '/profile/{sub}/kyc',

   // Vodafone IDP GW calls
   APPS_Lookup: '/consent/{sub}/lookup/apps',
   APPS_List: '/consent/{sub}/apps',
   APPS_Banned_List: '/consent/{sub}/banned/apps',
   APPS_Blacklisted_List: '/consent/{sub}/blacklisted/apps',
   APPS_Details: '/consent/{sub}/apps/{appId}',
   APPS_Remove_All_Apps_Tokens: '/consent/{sub}/tokens',
   APPS_Tokens_Delete: '/consent/{sub}/apps/{appId}/active-tokens',
   APPS_Remvove_Granted_App: '/consent/{sub}/apps/{appId}',
   APPS_Remove_Blacklisted_App: '/consent/{sub}/blacklisted/apps/{appId}',
   APPS_Remove_Banned_App: '/consent/{sub}/banned/apps/{appId}',
   APPS_Remove_All_Granted_Apps: '/consent/{sub}/apps',
   APPS_Remove_All_Bannend_Apps: '/consent/{sub}/banned/apps/',
   APPS_Remove_All_Blacklisted_Apps: '/consent/{sub}/blacklisted/apps/',
   APPS_Ban_App: '/consent/{sub}/banned/apps/{appId}',
   APPS_Blacklist_App: '/consent/{sub}/blacklisted/apps/{appId}',
   APPS_App_Update_Grant: '/consent/{sub}/apps/{appId}',

   // Vodafone GW Remember calls
   APPS_Remember_Me_All_Grant: '/consent/{sub}/remembers',
   APPS_Remember_Me_Grant: '/consent/{sub}/remembers/{seriesIdentifier}',
   APPS_Remember_Me_Remove_All_Grant: '/consent/{sub}/remembers',
   APPS_Remember_Me_Remove_Grant: '/consent/{sub}/remembers/{seriesIdentifier}',

   //Send OTP
   SEND_OTP: '/user/tokens',
   VERIFY_OTP: '/users/tokens/{token}/pins',

   // AAA calls
   AGENT: '/agent',
   AGENT_Operations_Logout: '/logout',
   AGENT_LASTLOGIN: '/agent/entries',

   //MC Connect calls
   MC_CONNECT_Update_service: '/consent/msisdn/{msisdn}/status/mc/{status}',
   MC_CONNECT_Get_service: '/user/{sub}/mcStatus',

   //Gateway History calls
   APPS_Gateway_HISTORY_All_Grant: '/user/{sub}/authorizations',

   //Mobile connect per service
   MC_CONNECT_per_service_data: '/user/{sub}/authorizations/last/apps',

   //Detail of heirarcy
   //DETIAL_DATA:'/contacts/{contactID}/contactroles',
   DETIAL_DATA:'/webusers/{sub}/contactroles',

});


export const SHAREDCONSTANTS = Object.freeze({
   // Possible Agent Actions
   ACTION_View: 'view',
   ACTION_Edit: 'edit',
   ACTION_Delete: 'delete',
   ACTION_KYC_Edit: 'kyc.write',

   AGENT_USER_RGHT_ERROR_MESSAGE: 'Problem with the user-rights. Either you have no role or you have no right to perform actions.',
   REDIRECT_URL_ERROR: 'Redirect URL not valid set from Backend!',
   COMMON_ERROR_MESSAGE: 'Application error occurred.',
   NO_VERIFIED_EMAIL_ERROR: 'The given email is not verified!',
   UPDATE_ERROR_409: 'The customer-data was updated meanwhile, please reload.',
   INVALID_FIRSTNAME_EXCEPTION : 'Invalid First name.',
   INVALID_LASTTNAME_EXCEPTION : 'Invalid Last name.',
   INVALID_COUNTRY_EXCEPTION : 'Invalid Country name.',
   INVALID_STREETADDRESS_EXCEPTION : 'Invalid Street address.',
   INVALID_REGION_EXCEPTION: 'Invalid Region.',
   INVALID_POSTALCODE_EXCEPTION : 'Invalid Postalcode.',
   INVALID_LOCALITY_EXCEPTION : 'Invalid Locality.',
   INVALID_BIRTHDATE_EXCEPTION : 'Invalid Birthdate.',
   INVALID_BIRTHPLACE_EXCEPTION : 'Invalid BirthPlace.',
   INVALID_EXPDATE_EXCEPTION : 'Invalid Expiration Date.',
   INVALID_ISSUEDATE_EXCEPTION : 'Invalid Issue Date.',
   FUTURE_ISSUEDATE_EXCEPTION : 'Issue Date should not be Future Date.',
   PAST_EXPDATE_EXCEPTION : 'Expiration Date should not be Past Date.',
   INVALID_PERSONALID_EXCEPTION : 'Invalid Personal ID.',
   INVALID_IDTYPE_EXCEPTION : 'Invalid Personal ID type.',
   INVALID_FISCALCODE_EXCEPTION : 'Invalid Fiscal Code.',
   INVALID_NATIONALITY_EXCEPTION : 'Invalid Nationality.',
   FUTURE_BIRTHDATE_EXCEPTION : 'Birthdate should not be Future Date.',
   INVALID_MSISDN_EXCEPTION : 'Please enter correct MSISDN.',
   EMAIL_EXISTS_EXCEPTION : 'Email already exists.',
   SAME_EMAIL_EXCEPTION : 'New email is same as current email.',
   SAME_PHONE_EXCEPTION : 'New phone number is same as current phone number.',
   MIN_TWO_CHARACTER : 'Please use at least two characters to search.',
   EMAIL_NOTPRESENT_EXCEPTION: 'Email not present in the Profile',
   EMAIL_NOTVERIFIED_EXCEPTION : 'Email provided is not verified',
   MSISDN_ALREADY_PRESENT_EXCEPTION : 'Email has already been used',
   ISSUEDATE_BEFORE_BIRTHDATE_EXCEPTION : 'Issue date should not be before birthdate.',
   USER_IDENTIFICATION_PENDING : 'MSISDN verification is pending.',
   OK_BUTTON_LABEL: "Ok",
   CANCEL_BUTTON_LABEL: "Cancel",
   CLOSE_BUTTON_LABEL: "Close",
   NO_DATA_FOUND: "No data found",

   CUSTOMER_UPDATE_SUCESS: 'Customer details updated successfully!',
   EMAIL_UPDATE_SUCESS: 'Email updated successfully!',
   MSISDN_UPDATE_SUCESS: 'Phone number updated successfully!'
});

export const OPCOVIEWLABELS = Object.freeze({
   SELECT_COUNTRY_LABEL: 'Market',
   SUBMIT_BUTTON_LABEL: 'Submit',
   BREADCRUMB: 'Select Market',
   HEADING: 'Select Market',
});

export const SEARCHVIEWLABELS = Object.freeze({
   SEARCH_USER_LABEL: 'Find a customer account',
   SELECTED_OPCO:'Selected Market',
   SELECTED_MARKET:'Selected Market',
   SUBMIT_BUTTON_LABEL: 'Search',
   BREADCRUMB: 'Search',
   HEADING: 'Find a customer account',
   TABLE_HEADER_ID: 'ID',
   TABLE_HEADER_COUNTRY: 'Country',
   TABLE_HEADER_PHONE_NUMBER: 'Phone Number',
   TABLE_HEADER_PHONE_VERIFIED: 'Phone Verified',
   TABLE_HEADER_EMAIL: 'Default Mail',
   TABLE_HEADER_ONLY_EMAIL: 'Mail',
   TABLE_HEADER_EMAIL_VERIFIED: 'MaPlease enter a valid emailil Verified',
   TABLE_HEADER_ACTIONS: 'Actions',
   TABLE_HEADER_ACTIONS_DETAILS_LABEL: 'Details',
   TABLE_HEADER_ACTIONS_DELETE_LABEL: 'Delete',
   TABLE_HEADER_ACTIONS_PREVIOUS_LABEL: 'Previous',
   TABLE_HEADER_ACTIONS_NEXT_LABEL: 'Next',
   ILLEGAL_FORMAT_ERROR: 'The entered search value is invalid.',
   NO_DATA_FOUND_ERROR: 'No data found.',
   CONFIRMATION_MESSAGE: 'Are you sure you want to delete this User?',
   CONFIRMATION_TITLE: 'Delete Confirmation',
   LETTER_SEARCH_ERROR: 'Please enter a valid email address or MSISDN.',
   CUSTOMER_DELETE_SUCCESS: 'Customer deleted successfully!',
   SEARCH_IDENTITY_SELECTOR_ATTRIBUTE:'Search Identity Attribute',
   IDENTITY_SELECTOR_ATTRIBUTE:'Identity Selector Attribute',
   NO_DATA:"NO Identity Attribute Found",
   RECOVERY_PHONE_NUMBERS_TITLE: 'Recovery phone numbers',
   RECOVERY_EMAILS_TITLE: 'Recovery emails',
});

export const DETAILSVIEWLABELS = Object.freeze({
   HEADING: 'Details',
   BREADCRUMB: 'Details',
   EMAIL_LABEL: 'Email',
   EMAIL_VERIFIY_BUTTON_LABEL: 'Verify',
   EMAIL_UPDATE_BUTTON_LABEL: 'Update',
   EMAIL_ADD_BUTTON_LABEL: 'Add Email',
   PHONE_NUMBER_LABEL: 'Phone Number',
   RECOVERY_EMAIL_LABEL: 'Recovery Email {i}',
   RECOVERY_PHONE_NUMBER_LABEL: 'Recovery Phone Number {i}',
   RECOVERY_EMAIL_VERIFIED_SUFFIX: 'Recovery Email {i} Verified',
   RECOVERY_PHONE_NUMBER_VERIFIED_SUFFIX: 'Recovery Phone Number {i} Verified',
   OTHER_OPERATIONS_HEADER: 'Other operations',
   OTHER_OPERATIONS_RESET_CUSTOMER_PASSWORD: 'Reset Customer Password',
   OTHER_OPERATIONS_ACTIVATE_ACCOUNT: 'Activate Account',
   OTHER_OPERATIONS_LOGOUT_CUSTOMER: 'Logout customer from services',
   OTHER_OPERATIONS_REMEMBER_ME: 'Remember Me',
   OTHER_OPERATIONS_MOBILE_CONNECT: 'Mobile Connect',
   OTHER_OPERATIONS_GATEWAY_HISTORY: 'Authorization History',

   ATTRIBUTES_HEADING: 'Attributes',
   ATTRIBUTES_UPDATE_BUTTON_LABEL: 'Update',
   ATTRIBUTES_TABLE_HEADER_NAME: 'Name',
   ATTRIBUTES_TABLE_HEADER_VALUE: 'Value',
   ATTRIBUTES_FIRST_NAME: 'First Name',
   ATTRIBUTES_MIDDLE_NAME: 'Middle Name',
   ATTRIBUTES_LAST_NAME: 'Last Name',
   ATTRIBUTES_PREFERRED_USERNAME: 'Preferred Username',
   ATTRIBUTES_NICKNAME: 'Nickname',
   ATTRIBUTES_STREET_ADDRESS: 'Street-Address',
   ATTRIBUTES_LOCALITY: 'City',
   ATTRIBUTES_REGION: 'Region',
   ATTRIBUTES_POSTAL_CODE: 'Postal-Code',
   ATTRIBUTES_COUNTRY: 'Country',
   ATTRIBUTES_GENDER: 'Gender',
   ATTRIBUTES_DATE_OF_BIRTH: 'Birthdate',
   ATTRIBUTES_PLACE_OF_BIRTH: 'Birthplace',
   ATTRIBUTES_1FA_VERIFIED: '1FA_User',
   ATTRIBUTES_LAST_MODIFIED_DATE: 'Last Modified Date',
   ATTRIBUTES_LAST_PASSWORD_UPDATE: 'Last Password Update',
   KYC_HEADING: 'KYC-ID Document Scan',
   KYC_UPDATE_BUTTON_LABEL: 'Update',
   KYC_HISTORY_BUTTON_LABEL: 'History',
   KYC_TABLE_HEADER_NAME: 'Name',
   KYC_TABLE_HEADER_VALUE: 'Value',
   KYC_TABLE_HEADER_HISTORY: 'History',
   KYC_TABLE_HEADER_TIMESTAMP: 'Timestamp',
   KYC_TABLE_HEADER_STATUS: 'Status',
   KYC_TABLE_HEADER_COMMENT: 'Comment',
   KYC_STATUS: 'ID Scan Status',
   KYC_ID: 'ID',
   KYC_LINK: 'Link',
   KYC_FISCAL_CODE: 'Fiscal Code',
   KYC_NATIONALITY: 'Nationality',
   KYC_PID_TYPE: 'ID-Type',
   KYC_PID_NUMBER: 'ID-Number',
   KYC_PID_ISSUE_DATE: 'Issue date',
   KYC_PID_ISSUE_PLACE: 'Issue place',
   KYC_PERSONAL_ID_EXPIRATION_DATE: 'Expiration date',
   KYC_LAST_UPDATED: 'Last updated',

   KYC_MODAL_TITLE: 'KYC History',
   KYC_COMPLETENESS_HEADING:'KYC - Completeness',
   KYC_COMPLETENESS_STATUS:'Completeness Status',
   KYC_COMPLETENESS_LAST_UPDATE:'Last update',
   FIXED_ATTRIBUTES_HEADING: 'Fixed Attributes',
   FIXED_ATTRIBUTES_TABLE_HEADER_NAME: 'Name',
   FIXED_ATTRIBUTES_TABLE_HEADER_VALUE: 'Value',
   FIXED_ATTRIBUTES_USERNAME: 'Username',
   FIXED_ATTRIBUTES_STATUS: 'Status',
   FIXED_ATTRIBUTES_LANGUAGE: 'Language',
   FIXED_ATTRIBUTES_BLOCKED: 'Blocked',
   FIXED_ATTRIBUTES_CREATED: 'Created',
   FIXED_ATTRIBUTES_UPDATED: 'Updated',

   SERVICES_HEADING: 'Services',
   SERVICES_NO_APPS_FOUND: 'No entries found.',
   SERVICES_TABLE_HEADER_NAME: 'Name',
   SERVICES_TABLE_HEADER_EDIT: 'Edit',
   SERVICES_TABLE_HEADER_ICON: 'Icon',
   SERVICES_SINGLE_APP: 'Single App',
   SERVICES_ALL_APPS: 'All App',
   SERVICES_REMOVE_ALL_APPS_TOKENS: 'Remove all tokens',
   SERVICES_REMOVE_ALL_GRANTED_APPS: 'Remove all granted apps',
   SERVICES_REMOVE_ALL_BANNED_APPS: 'Remove all banned apps',
   SERVICES_REMOVE_ALL_BLACKLISTED_APPS: 'Remove all blacklisted apps',
   SERVICES_REMOVE_APP: 'Remove app',
   SERVICE_REMOVE_APP_CONFIRM_MESSAGE: 'Do you really want to remove this app?',
   SERVICE_REMOVE_ALL_APPS_CONFIRM_MESSAGE: 'Do you really want to remove all apps of this state?',
   SERVICE_REMOVE_ALL_APPS_TOKENS_CONFIRM_MESSAGE: 'Do you really want to remove all apps tokens?',
});

export const APPSVIEWLABELS = Object.freeze({

   APP_STATUS_BANNED: 'BANNED',
   APP_STATUS_BLACKLISTED: 'BLACKLISTED',
   APP_STATUS_GRANTED: 'GRANTED',

   MODAL_TITLE_SINGLE: 'Service: ',
   TABLE_HEADER_NAME: 'Name',
   TABLE_HEADER_VALUE: 'Value',
   APPID: 'App-ID',
   APPNAME: 'App-Name',
   DESCRIPTION: 'Description',
   CREATION_TIME: 'Creation-Time',
   LAST_UPDATE_TIME: 'Last Update-Time',
   EXPIRATION_TIME: 'Expiration-Time',
   STATUS: 'Status',
   LOGO_URI: 'Logo-URI',
   TOS_URI: 'TOS-URI',
   POLICY_URI: 'Policy-URI',

   DELETE_SINGLE_APP_TOKENS_BUTTON_LABEL: 'Remove Tokens',
   BAN_SINGLE_APP_BUTTON_LABEL: 'Ban App',
   UPDATE_SINGLE_APP_GRANT_BUTTON_LABEL: 'Update',
   BLACKLIST_SINGLE_APP_BUTTON_LABEL: 'Blacklist App',
});

export const USERUPDATEVIEWLABELS = Object.freeze({
   MODAL_TITLE: 'Attributes Update',
   TABLE_HEADER_NAME: 'Name',
   TABLE_HEADER_VALUE: 'Value',
   FIRST_NAME: 'First Name',
   MIDDLE_NAME: 'Middle Name',
   LAST_NAME: 'Last Name',
   PREFERRED_USERNAME: 'Preferred Username',
   NICKNAME: 'Nickname',
   STREET_ADDRESS: 'Street-Address',
   LOCALITY: 'City',
   REGION: 'Region',
   POSTAL_CODE: 'Postal-Code',
   COUNTRY: 'Country',
   GENDER: 'Gender',
   GENDER_OPTIONS: ['Male', 'Female'],
   DATE_OF_BIRTH: 'Birthdate',
   PLACE_OF_BIRTH: 'Birthplace',
   CLOSE_BUTTON_LABEL: 'Close',
   CONFIRM_BUTTON_LABEL: 'Confirm',
});

export const MAILUPDATEVIEWLABELS = Object.freeze({
   MODAL_TITLE: 'Email Update',
   HEADING: 'Enter a new Email-Address',
   CURRENT_EMAIL_LABEL: 'Current Email',
   NEW_EMAIL_LABEL: 'New Email',
   CLOSE_BUTTON_LABEL: 'Close',
   CONFIRM_BUTTON_LABEL: 'Confirm',
});

export const MSISDNUPDATEVIEWLABELS = Object.freeze({
   MODAL_TITLE: 'Phone Number Update',
   HEADING: 'Enter a new Phone Number',
   CURRENT_MSISDN_LABEL: 'Current Phone Number',
   NEW_MSISDN_LABEL: 'New Phone Number',
   CLOSE_BUTTON_LABEL: 'Close',
   CONFIRM_BUTTON_LABEL: 'Confirm',
   OTP_BUTTON_LABEL: 'Send OTP'
});

export const MSISDNCONFIRMVIEWLABELS = Object.freeze({
   MODAL_TITLE: 'Phone Number Update',
   HEADING: 'You must confirm the identify of the customer before updating their Phone Number.',
   CLOSE_BUTTON_LABEL: 'Close',
   CONFIRM_BUTTON_LABEL: 'Confirm',
});

export const MOBILECONNECTLABELS = Object.freeze({
   MODAL_TITLE: 'Mobile Connect Service',
   HEADING: 'Please select option to update mobile connect service.',
   CLOSE_BUTTON_LABEL: 'Close',
   CONFIRM_BUTTON_LABEL: 'Submit',
   ACTIVATE:'Activate',
   DEACTIVATE: 'De-Activate',
   BLOCK:'Block'
});

export const MAILADDVIEWLABELS = Object.freeze({
   MODAL_TITLE: 'Email Add',
   HEADING: 'Enter a new Email-Address',
   NEW_EMAIL_LABEL: 'New Email',
   CLOSE_BUTTON_LABEL: 'Close',
   CONFIRM_BUTTON_LABEL: 'Confirm',
});

export const KYCUPDATEVIEWLABELS = Object.freeze({
   FIXED_HEADER: 'Data',
   KYC_DETAILS_HEADER: 'KYC-Details',
   PERSONAL_ID_HEADER: 'Personal ID',

   MODAL_TITLE: 'KYC Update',
   TABLE_HEADER_NAME: 'Name',
   TABLE_HEADER_VALUE: 'Value',
   STATUS: 'Status',
   STATUS_OPTIONS_REAL_VALUES: ['not-started', 'in-progress', 'verified', 'rejected'],
   STATUS_OPTIONS_SHOWN_VALUES: ['Not-Started', 'In Progress', 'Verified', 'Rejected'],
   EXTERNAL_REFERENCE_ID: 'External reference ID',
   EXTERNAL_REFERENCE_LINK: 'External referenceLink',
   COMMENT: 'Comment',
   STREET_ADDRESS: 'Street-Address',
   LOCALITY: 'City',
   REGION: 'Region',
   POSTAL_CODE: 'Postal-Code',
   COUNTRY: 'Country',
   FIRSTNAME: 'First Name',
   LASTNAME: 'Last Name',
   BIRHTDATE: 'Date of birth',
   BIRTHPLACE: 'Place of birth',
   NATIONALITY: 'Nationality',
   PERSONAL_ID_TYPE: 'ID Type',
   PERSONAL_ID_NUMBER: 'ID number',
   PERSONAL_ID_ISSUE_DATE: 'Issue date',
   PERSONAL_ID_PLACE_OF_ISSUE: 'Issue place',
   PERSONAL_ID_EXPIRATION_DATE: 'Expiration date',

   FISCAL_CODE: 'Fiscal Code',
   CLOSE_BUTTON_LABEL: 'Close',
   CONFIRM_BUTTON_LABEL: 'Confirm',
});

export const KYCUPDATEVIEWMESSAGES = Object.freeze({
   KYC_ISSUE_DATE_REQUIRED: 'Please enter valid Issue Date.',
   KYC_EXPIRATION_DATE_REQUIRED: 'Please enter valid Expiration Date.',
   KYC_UPDATE_SUCCESS: 'KYC details updated successfully!',
   USER_PROFILE_NOT_FOUND: 'User profile details not found.'
});

export const USERSESSIONVIEWLABELS = Object.freeze({
   MY_ACCOUNT_LINK_LABEL: 'My Account',
   MY_ACCOUNT_LINK: 'https://aaa-pre.ena.sp.vodafone.com/idm/admin/?aaa:action=myaccount',
   MY_ACCOUNT_LINK_PRE: 'https://aaa-pre.ena.sp.vodafone.com/idm/admin/?aaa:action=myaccount',
   MY_ACCOUNT_LINK_PROD: 'https://aaa.ena.sp.vodafone.com/idm/admin/?aaa:action=myaccount',
   LOGOUTLINK: 'Logout',
   LASTLOGINSUCESS: 'Last successful login was',
   LASTLOGINERROR: 'Last login attempt failed on'
});

export const GRANTUPDATEVIEWLABELS = Object.freeze({
   MODAL_TITLE: 'Select all scopes to be granted',
   CLOSE_BUTTON_LABEL: 'Close',
   CONFIRM_BUTTON_LABEL: 'Confirm',
   EXPIRATION_LABEL: 'Expiration'
});

export const LOGOUTVIEWLABELS = Object.freeze({
   MODAL_TITLE: 'Logout',
   HEADING: 'Are you sure you want to logout now?',
   CLOSE_BUTTON_LABEL: 'Close',
   CONFIRM_BUTTON_LABEL: 'Confirm',
}); 

export const RESETVIEWLABELS = Object.freeze({
   MODAL_TITLE: 'Reset',
   HEADING: 'Are you sure?',
   CLOSE_BUTTON_LABEL: 'Close',
   CONFIRM_BUTTON_LABEL: 'Confirm',
});

export const REMEMBERMELABELS = Object.freeze({
   MODAL_TITLE: 'Remember Me',
   HEADING: 'Remember Me',
   CLOSE_BUTTON_LABEL: 'Close',
   TABLE_HEADER_ACTIONS_PREVIOUS_LABEL: 'Previous',
   TABLE_HEADER_ACTIONS_NEXT_LABEL: 'Next',
   USER_AGENT: 'User Agent',
   CREATION_DATE: 'Creation Date',
   EXPIRATION_DATE: 'Expiration Date',
   DEVICE: 'Device',
   DELETE: 'Delete',
   NO_DATA_FOUND_ERROR: 'No data found.',
   NO_REMEMBER_ME_DATA_FOUND: 'No remember me data found.',
   DELETE_REMEMBER_ME_COOKIE_CONFIRM_MESSAGE: 'Are you sure you want to delete this Cookie?',
   DELETE_REMEMBER_ME_ALL_COOKIE_CONFIRM_MESSAGE: 'Are you sure you want to delete all Cookies?',
   REMEMBER_ME_DATA_DELETE_SUCCESS_MESSAGE: 'Remember me data deleted successfully!'
});

export const GATEWAYHISTORYLABELS = Object.freeze({
   MODAL_TITLE: 'Authorization History',
   HEADING: 'Gateway History',
   CLOSE_BUTTON_LABEL: 'Close', 

   TIME_OF_REQUEST: 'Time Of Request',
   CLIENT_ID: 'Client ID',
   CLIENT_NAME: 'Client Name',
   LOA_ACHIEVED: 'LOA Achieved',
   MARKET_ID: 'Market',
   AUTHORIZATION_ID: 'Authorization ID',
   STATUS: 'Status',

   DELETE: 'Delete',
   NO_DATA_FOUND_ERROR: 'No data found.',
});

export const SMSURLLABELS = Object.freeze({
   HEADING: 'Please verify the phone number',
   VERIFY_BUTTON_LABEL: 'Verify',
   CANCEL_BUTTON_LABEL: 'Cancel',
   CLOSE_TITLE: 'Your request has been cancelled.'
});

export const ACTIVATEACCOUNTLABELS = Object.freeze({
   MODAL_TITLE: 'Activate Account',
   CLOSE_BUTTON_LABEL: 'Close',
   CONFIRM_BUTTON_LABEL: 'Confirm',
   HEADING: "Are you sure you want to activate this account?",
   RO_ACTIVATE_ACCOUNT_SUCCESS: "Activate account email sent",
   RO_ACTIVATE_ACCOUNT_FAILURE: "Something went wrong with the activation",
   RO_ACTIVATE_ACCOUNT_WEBUSER_NOT_FOUND: "Webuser is not in pending status or channel is not AAA"
});

export const UNLOCKACCOUNTLABELS = Object.freeze({
   MODAL_TITLE: 'Unlock Customer Account',
   CLOSE_BUTTON_LABEL: 'Close',
   CONFIRM_BUTTON_LABEL: 'Confirm',
   HEADING: "Are you sure you want to unlock this account?",
});

export const STATUS_OPTIONS_DEFAULT = {
   ACTIVE: "Active",
   DISABLED: "Disabled",
   PENDING: "Pending"
};

export const STATUS_OPTIONS_VO = {
   ACTIVE: "Active",
   SUSPENDED: "Suspended",
   PENDING: "Pending"
};



// WEBPACK FOOTER //
// ./src/app/_constants/constants.ts